import { ITableCol } from "@data/interfaces/itable.interface";
import { ACTIVE_STATUS_COLOR_ENUM, ACTIVE_STATUS_ENUM } from "@modules/private/active/data/enum/active.enum";

export const ACTIVE_STATUS_OPTIONS = [
  { value: 'Activo', label: 'Activo' },
  { value: 'Baja', label: 'Baja' }
]

export const ACTIVE_COLUMNS: ITableCol[] = [
  { type: 'text', field: '_id', header: 'Id del Activo', showFilter: false, dataType: 'link', linkField: '_id', rootLink: 'active' },
  { type: 'text', field: 'name', header: 'Nombre del Activo', showFilter: true },
  { type: 'text', field: 'client.name', header: 'Cliente', showFilter: true },
  { type: 'text', field: 'lease', header: 'Folio del Arrendamiento', showFilter: true },
  { type: 'number', field: 'acquisition.total', header: 'Valor Total', dataType: 'currency', showFilter: true },
  { type: 'text', field: 'category', header: 'Categoria', showFilter: true },
  { type: 'text', field: 'brand', header: 'Marca', showFilter: true },
  { type: 'text', field: 'assetModel', header: 'Modelo', showFilter: true },
  { type: 'text', field: 'serie', header: 'Serie', showFilter: true },
  { type: 'text', field: 'version', header: 'Versión', showFilter: true },
  { type: 'text', field: 'color', header: 'Color', showFilter: true },
  { type: 'text', field: 'engineNumber', header: 'Número de Motor', showFilter: true },
  // { type: 'text', field: 'description', header: 'Descripción', showFilter: true },
  { type: 'enum', field: 'status', header: 'Estatus', showFilter: true, dataType: 'enum', enum: ACTIVE_STATUS_ENUM, enumColor: ACTIVE_STATUS_COLOR_ENUM, options: ACTIVE_STATUS_OPTIONS },
]

export const ACTIONS = [
  { icon: 'fa-regular fa-pen-to-square', action: 'EDIT', title: 'Editar', color: 'primary', permission: ['assets', 'update'] as [string, string] },
]